import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DbContextService } from '../../../services/db-context.service';
import { OfflineQueueService } from '../../../services/offline-queue.service';
import { OnlineOfflineService } from '../../../services/online-offline.service';
import { Helper } from '../../common/helper';
import { DailyMealsAndFees, DailyMealsAndFeesDetails } from '../model/daily-meals-entry';
import { DailyMealsOverviewData } from '../model/daily-meals-overview';
import swal from 'sweetalert2';
import { DataFormatter } from '../../common/dataFormatter';

@Injectable({
  providedIn: 'root'
})
export class DailyMealsOverviewService {

  constructor(
    private http: HttpClient,
    private dbxService: DbContextService) { }

  getDailyMealOverview() {

    return this.http.post(Helper.API_URL() + '/api/budget/GetDailyMealsOverview', {});
  }

  getDailyMealsAndFeesTempData(shipID: number) {
    return this.http.get(Helper.API_URL() + '/api/Budget/GetDailyMealsAndFeesTempData/' + `${shipID}`);
  }

  deleteDailyMealsAndFeesTempData(headerID: string) {
    let paramObject = {
      'headerID': headerID
    }
    return this.http.post(Helper.API_URL() + '/api/Budget/DeleteDailyMealsAndFeesTempData', paramObject);
  }

  getDailyMealOverviewIntoIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.getDailyMealOverview().subscribe((res: any) => {
        //this.saveSubmittedDMOverviewIndxDb(res.entity.submittedDMList);
        //this.saveApprovedDMOverviewIndxDb(res.entity.approvedDMList);
        this.saveUpdatedSubmittedDMOverviewIndexDB(res.entity.submittedDMList);
        this.saveUpdatedApprovedDMOverviewIndexDB(res.entity.approvedDMList);
      })
    })
    return promise;
  }

  //IndexDB functions ---------------------------------------------------------
  getOpenDMOverviewIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let openDm: DailyMealsOverviewData[] = [];
      this.dbxService.openDatabase().then(db => {
        let txstoreOpen = db.transaction('OWS_tblDailyMealsAndFees', 'readwrite');
        let storeOpen = txstoreOpen.objectStore('OWS_tblDailyMealsAndFees');
        storeOpen.getAll().then((res: DailyMealsAndFees[]) => {
          res.forEach((dm: DailyMealsAndFees) => {
            if (this.isPending(dm.dailyMealsAndFeesID) && dm.isSubmitted == false && dm.isApproved == false) {
              let obj: DailyMealsOverviewData = {
                dailyMealsAndFeesID: dm.dailyMealsAndFeesID,
                beginDate: DataFormatter.ToDate(dm.beginDate.toString()),
                endDate: DataFormatter.ToDate(dm.endDate.toString()),
                days: dm.days,
                averageMenPerDay: dm.averageMenPerDay,
                specialAverageMenPerDay: dm.specialAverageMenPerDay,
                extraAverageMenPerDay: dm.extraAverageMenPerDay,
                isApproved: dm.isApproved,
                isUpdatedOffline: false,
                uploaded: true,
                lastSavedHash: dm.lastSavedHash,
                isChangedLastSave: dm.isChangedLastSave,
              }
              openDm.push(obj);
            }
          })
          resolve(openDm);
        })
      })
    })
    return promise;
  }

  getSubmittedDMOverviewIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let submittedDm: DailyMealsOverviewData[] = [];

      //get submitted from db
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDMOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblDMOverviewSubmitted');
        store.getAll().then((res: DailyMealsOverviewData[]) => {
          res.forEach((dm: DailyMealsOverviewData) => {
            if (dm.isApproved == false) {
              submittedDm.push(dm);
            }
          })
        }).then((res: any) => {
          //get submitted offline from open list
          let txstoreOpen = db.transaction('OWS_tblDailyMealsAndFees', 'readwrite');
          let storeOpen = txstoreOpen.objectStore('OWS_tblDailyMealsAndFees');
          storeOpen.getAll().then((res: DailyMealsAndFees[]) => {
            res.forEach((dm: DailyMealsAndFees) => {
              if (this.isPending(dm.dailyMealsAndFeesID) && dm.isSubmitted == true && dm.isApproved == false) {
                let obj: DailyMealsOverviewData = {
                  dailyMealsAndFeesID: dm.dailyMealsAndFeesID,
                  beginDate: DataFormatter.ToDate(dm.beginDate.toString()),
                  endDate: DataFormatter.ToDate(dm.endDate.toString()),
                  days: dm.days,
                  averageMenPerDay: dm.averageMenPerDay,
                  specialAverageMenPerDay: dm.specialAverageMenPerDay,
                  extraAverageMenPerDay: dm.extraAverageMenPerDay,
                  isApproved: dm.isApproved,
                  isUpdatedOffline: true,
                  uploaded: true,
                  lastSavedHash: dm.lastSavedHash,
                  isChangedLastSave: dm.isChangedLastSave,
                }
                submittedDm.push(obj);
              }
            })
            resolve(submittedDm);
          })
        })
      })
    })
    return promise;
  }
  private isPending(dmfId: any): boolean {
    return isNaN(Number(dmfId.toString()));
  }
  getApprovedDMOverviewIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let approvedDM: DailyMealsOverviewData[] = [];

      this.dbxService.openDatabase().then(db => {
        //get approved from db
        let tx = db.transaction('OWS_tblDMOverviewApproved', 'readwrite');
        let store = tx.objectStore('OWS_tblDMOverviewApproved');
        store.getAll().then((res: DailyMealsOverviewData[]) => {
          res.forEach((dm: DailyMealsOverviewData) => {
            approvedDM.push(dm);
          })
        }).then((res: any) => {
          //get approved offline from submitted list
          let txstoreSubmitted = db.transaction('OWS_tblDMOverviewSubmitted', 'readwrite');
          let storeSubmitted = txstoreSubmitted.objectStore('OWS_tblDMOverviewSubmitted');
          storeSubmitted.getAll().then((res: DailyMealsOverviewData[]) => {
            res.forEach((dm: DailyMealsOverviewData) => {
              if (dm.isUpdatedOffline != null && dm.isUpdatedOffline == true && dm.isApproved != null && dm.isApproved == true) {
                approvedDM.push(dm);
              }
            })
          }).then((res: any) => {
            resolve(approvedDM);
          })
        })
      });
    });
    return promise;
  }

  saveSubmittedDMOverviewIndxDb(dmList: DailyMealsOverviewData[]): Promise<Object> {
    let promise = new Promise<any>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDMOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblDMOverviewSubmitted');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.getAll().then((res: DailyMealsOverviewData[]) => {
          res.forEach((dm: DailyMealsOverviewData) => {
            if (dm.isUpdatedOffline == null || dm.isUpdatedOffline == false) {
              store.delete(dm.dailyMealsAndFeesID);
            }
          })
        })

        if (dmList != null) {
          dmList.forEach((dm: DailyMealsOverviewData) => {
            store.get(dm.dailyMealsAndFeesID).then((res: DailyMealsOverviewData) => {
              if (res == null) {
                try {
                  store.add(dm);
                } catch (e: any) {
                  if (e?.name === 'QuotaExceededError') {
                    this.handleQuotaExceeded();
                  }
                }
              } else {
                if (res.isUpdatedOffline == null || res.isUpdatedOffline == false) {
                  try {
                    store.put(dm);
                  } catch (e: any) {
                    if (e?.name === 'QuotaExceededError') {
                      this.handleQuotaExceeded();
                    }
                  }
                }
              }
            })
            resolve(null);
          })
        }
      })
    });
    return promise;
  }
  saveApprovedDMOverviewIndxDb(dmList: DailyMealsOverviewData[]): Promise<Object> {
    let promise = new Promise<any>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDMOverviewApproved', 'readwrite');
        let store = tx.objectStore('OWS_tblDMOverviewApproved');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.clear();
        if (dmList != null) {
          dmList.forEach((dm: DailyMealsOverviewData) => {
            try {
              store.add(dm);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          })
        }
        resolve(null);
      })
    });
    return promise;
  }

  markApprovedDMOverviewIndxDb(dmfId: any) {
    this.dbxService.openDatabase().then(db => {
      let tx = db.transaction('OWS_tblDMOverviewSubmitted', 'readwrite');
      let store = tx.objectStore('OWS_tblDMOverviewSubmitted');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      store.get(dmfId).then((res: DailyMealsOverviewData) => {
        if (res != null) {
          res.isApproved = true;
          res.isUpdatedOffline = true;
          try {
            store.put(res);
          } catch (e: any) {
            if (e?.name === 'QuotaExceededError') {
              this.handleQuotaExceeded();
            }
          }
        }
      })
    })
  }

  cancelDMOverviewIndxDb(dmfId: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      //delete from header
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDailyMealsAndFees', 'readwrite');
        let store = tx.objectStore('OWS_tblDailyMealsAndFees');
        store.getAll().then((res: DailyMealsAndFees[]) => {
          let header: DailyMealsAndFees[] = res.filter(r => r.dailyMealsAndFeesID == dmfId);
          header.forEach((d: DailyMealsAndFees) => {
            store.delete(d.dailyMealsAndFeesID);
          })
        })
      });

      this.dbxService.openDatabase().then(db => {
        //delete details
        let txstoreOpenDet = db.transaction('OWS_tblDailyMealsAndFeesDetails', 'readwrite');
        let storeOpenDet = txstoreOpenDet.objectStore('OWS_tblDailyMealsAndFeesDetails');
        storeOpenDet.getAll().then((res: DailyMealsAndFeesDetails[]) => {
          let details: DailyMealsAndFeesDetails[] = res.filter(r => r.dailyMealsAndFeesID == dmfId);
          details.forEach((d: DailyMealsAndFeesDetails) => {
            storeOpenDet.delete(d.dailyMealsAndFeesDetailsID);
          })
        })
      });
      resolve(dmfId);
    })
    return promise;
  }

  updateSubmittedDMOverviewIndxDb(dailyMealsAndFeesID: any) {
    this.dbxService.openDatabase().then(db => {
      let tx = db.transaction('OWS_tblDMOverviewSubmitted', 'readwrite');
      let store = tx.objectStore('OWS_tblDMOverviewSubmitted');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      store.get(Number(dailyMealsAndFeesID)).then(
        (res: any) => {
          if (res) {
            res.isSubmitted = true;
            try {
              store.put(res);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          }
        });
    });
  }

  saveUpdatedSubmittedDMOverviewIndexDB(dmList: any): Promise<Object> {
    let promise = new Promise<any>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDMOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblDMOverviewSubmitted');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.clear();
        if (dmList.length > 0) {
          dmList.forEach((dm: DailyMealsOverviewData) => {
            store.get(dm.dailyMealsAndFeesID).then((res: DailyMealsOverviewData) => {
              if (res) {
                try {
                  store.put(dm);
                } catch (e: any) {
                  if (e?.name === 'QuotaExceededError') {
                    this.handleQuotaExceeded();
                  }
                }
              } else {
                try {
                  store.add(dm);
                } catch (e: any) {
                  if (e?.name === 'QuotaExceededError') {
                    this.handleQuotaExceeded();
                  }
                }
              }
            })
            resolve(null);
          })
        } else {
          resolve(null);
        }
      })
    });

    return promise;
  }

  saveUpdatedApprovedDMOverviewIndexDB(dmList: any): Promise<Object> {
    let promise = new Promise<any>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDMOverviewApproved', 'readwrite');
        let store = tx.objectStore('OWS_tblDMOverviewApproved');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.clear();
        if (dmList.length > 0) {
          dmList.forEach((dm: DailyMealsOverviewData) => {
            store.get(dm.dailyMealsAndFeesID).then((res: DailyMealsOverviewData) => {
              if (res) {
                try {
                  store.put(dm);
                } catch (e: any) {
                  if (e?.name === 'QuotaExceededError') {
                    this.handleQuotaExceeded();
                  }
                }
              } else {
                try {
                  store.add(dm);
                } catch (e: any) {
                  if (e?.name === 'QuotaExceededError') {
                    this.handleQuotaExceeded();
                  }
                }
              }
            })
            resolve(null);
          })
        } else {
          resolve(null);
        }
      })
    });

    return promise;
  }

  getSaveCrewTypesIndexDB(crewTypeList: any[]) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblDMCrewTypes', 'readwrite');
      let store = tx.objectStore('OWS_tblDMCrewTypes');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };
      store.clear();
      crewTypeList.forEach(crewType => {
        try {
          store.add(crewType);
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }
      })
    });
  }

  getSaveMealsIndexDB(meals: any[]) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblMeals', 'readwrite');
      let store = tx.objectStore('OWS_tblMeals');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      store.clear();
      meals.forEach(meal => {
        try {
          store.add(meal);
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }
      })
    });
  }

  getSaveCrewSubTypesIndexDB(meals: any[]) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblDMCrewSubTypes', 'readwrite');
      let store = tx.objectStore('OWS_tblDMCrewSubTypes');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      store.clear();
      meals.forEach(meal => {
        store.add(meal);
      })
    });
  }

  getSaveContractsIndexDB(contractList: any[]) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblContracts', 'readwrite');
      let store = tx.objectStore('OWS_tblContracts');
      store.clear();
      contractList.forEach(contract => {
        try {
          store.add(contract);
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }
      })
    });
  }

  saveOpenDailyMealsAndFeesIndexDb(list: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDailyMealsAndFees', 'readwrite');
        let store = tx.objectStore('OWS_tblDailyMealsAndFees');

        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };
        list.forEach((s: any) => {
          store.get(s.dailyMealsAndFeesTemp.dailyMealsAndFeesID).then((res: any) => {
            if (res == null) {
              try {
                let req = store.add(s.dailyMealsAndFeesTemp);
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            }
          });
        })

        resolve(true);
      });
    });

    return promise;
  }

  saveOpenDailyMealsAndFeesDetailsIndexDb(list: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDailyMealsAndFeesDetails', 'readwrite');
        let store = tx.objectStore('OWS_tblDailyMealsAndFeesDetails');

        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        list.forEach((s: any) => {
          s.dailyMealsAndFeesDetailsTempList.forEach((t: any) => {
            store.get(t.dailyMealsAndFeesDetailsID).then((res: any) => {
              if (res == null) {
                try {
                  let req = store.add(t);
                } catch (e: any) {
                  if (e?.name === 'QuotaExceededError') {
                    this.handleQuotaExceeded();
                  }
                }
              }
            });

          })
        })

        resolve(true);
      });
    });

    return promise;
  }

  /** Print: -------------------------- **/

  printDailyMeals(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Budget/PrintDailyMeals', data, { responseType: 'arraybuffer' as 'json' });
  }

  // Upload
  getDailyMealsFilesList(DailyMealsIDList: string, docFileNameList?: string) {

    docFileNameList = (docFileNameList) ? docFileNameList : 'ALL';

    const paramObject = {
      'dailyMealsIDList': DailyMealsIDList,
      'docFileNameList': docFileNameList,
    }

    return this.http.post(Helper.API_URL() + '/api/Budget/GetDailyMealsFilesList', paramObject);
  }

  uploadDailyMealsFile(file: any) {
    return this.http.post(Helper.API_URL() + '/api/Budget/UploadDailyMealsFile', file);
  }

  createDailyMealsFile(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Budget/CreateDailyMealsFile', data);
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
